<template>
  <div class="textile__item">
    <div class="textile__container">
      <h3 class="c__subhead navy c__no__anm">{{ textile.name }}</h3>
      <div class="textile__carousel__wrap">
        <div ref="carousel" class="textile__carousel">
          <div class="textile__img__wrap" :class="{ 'one-item': textile.items.length === 1 }">
            <div
              v-for="(item, index) in textile.items"
              :key="`${index}-${item.name}`"
              class="slide"
              :class="{ 'slide-active': activeIndex === index }"
              @click="emblaApi?.scrollTo(index)"
            >
              <div class="slide-container">
                <AtomsConsumerLink
                  :url="item.url || `/night-conditioning/recovery-wear?fabric=${item.fabric}`"
                  :disabled="activeIndex !== index"
                >
                  <div class="textile__img__item">
                    <p class="textile__title">{{ item.name }}</p>
                    <div class="textile__img">
                      <AtomsConsumerImage :src="item.image" :alt="item.title" :width="800" :height="800" />
                    </div>
                    <div class="caption__wrap">
                      <AtomsConsumerImage
                        src="/images/site/feature/howtochoose_recoverywear_sleepitem/each_arrow.png"
                        alt="arrow"
                        :width="43"
                        :height="43"
                        class="each__icon"
                      />
                      <AtomsConsumerImage
                        :src="item.bakuneImage"
                        :alt="`${item.title}のBAKUNE`"
                        :width="100"
                        :height="100"
                        class="caption__img"
                      />
                      <div class="caption__text">
                        <p class="caption__head">
                          {{ item.title }}
                        </p>
                        <p class="caption__body">
                          {{ item.description }}
                        </p>
                      </div>
                    </div>
                  </div>
                </AtomsConsumerLink>
              </div>
            </div>
          </div>
        </div>
        <div v-if="textile.items.length > 3" class="swiper-button-next" @click="emblaApi?.scrollNext()">
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/next-icon.svg"
            alt="次の素材"
            :width="24"
            :height="24"
          />
        </div>
        <div v-if="textile.items.length > 3" class="swiper-button-prev" @click="emblaApi?.scrollPrev()">
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/prev-icon.svg"
            alt="前の素材"
            :width="24"
            :height="24"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import emblaCarouselVue from "embla-carousel-vue"
import type { TextileItem } from "~/utils/functions/howtochoose_recoverywear_sleepitem"

const [carousel, emblaApi] = emblaCarouselVue({ loop: true })

const props = defineProps<{
  textile: TextileItem
  selectedTextileIndex: number
}>()

const emit = defineEmits<{
  (e: "change", index: number): void
}>()

watch(
  emblaApi,
  (api) => {
    if (api) {
      api.on("select", (event) => {
        activeIndex.value = event.selectedScrollSnap()
      })
      api.on("init", (event) => {
        event.scrollTo(activeIndex.value, true)
      })
    }
  },
  { immediate: true },
)

const activeIndex = computed({
  get: () => props.selectedTextileIndex,
  set: (val: number) => emit("change", val),
})
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
